import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestTableComponent } from './request-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ToastModule } from 'primeng/toast';

@NgModule({
  declarations: [
    RequestTableComponent
  ],
  imports: [
    CommonModule,
    ToastModule,
    NgxSkeletonLoaderModule.forRoot({
      theme: {
        // Enabliong theme combination
        extendsFromRoot: true,
        // ... list of CSS theme attributes
        height: '72px',
        width: '100%',
        margin: '10px 0px'
      },
    }),
  ],
  exports: [
    RequestTableComponent,
  ]
})
export class RequestTableModule { }
